import { Link } from 'react-router-dom';
import { sportCategories } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="text-2xl font-heading font-bold text-primary-400 tracking-wider whitespace-nowrap cursor-pointer">九州体育</Link>
              <p className="mt-3 text-sm text-background-300 leading-relaxed">
                全场景体育服务平台，为每一位体育爱好者提供极致的赛事直播、体育资讯、竞猜娱乐及运动健康服务。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">体育分类</h4>
              <ul className="space-y-2.5">
                {sportCategories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link></li>
                <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">会员注册</a></li>
                <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">App下载</a></li>
                <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">帮助中心</a></li>
                <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">用户协议</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5 text-sm text-background-400">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>service@jiuzhousports.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-primary-400"></i>
                  <span>400-888-9999</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-primary-400"></i>
                  <span>北京市朝阳区体育中心</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 九州体育 版权所有 | 京ICP备xxxxxxxx号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博"><i className="ri-weibo-line text-lg"></i></a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信"><i className="ri-wechat-line text-lg"></i></a>
              <a href="#" className="text-background-500 hover:text-primary-400 transition-colors cursor-pointer" aria-label="抖音"><i className="ri-tiktok-line text-lg"></i></a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}